import React from "react";
import { RouteComponentProps } from "react-router-dom";

export function NotFoundPage(props: RouteComponentProps) {
  return <div>Not found</div>;
}
